import { Button, Typography } from 'antd';
import { useEffect, useRef, useState } from 'react';
import SignaturePad from 'react-signature-pad-wrapper';
import styled from 'styled-components';
import SimpleDrawer from '../../../SimpleDrawer';

const StyledDrawer = styled(SimpleDrawer)`
	.ant-drawer-body {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
`;

const Footer = styled.div`
	display: flex;
	width: 100%;
	gap: 5px;

	button {
		margin-top: auto;
		flex: 1;
	}
`;

interface Props {
	value?: string;
	onChange?: (key?: string) => void;
	title: string;
	buttonText: string;
}

const SignatureItem: React.FC<Props> = ({ value, title, buttonText, onChange }) => {
	const signaturePadRef = useRef<SignaturePad>(null);
	const [forceNew, setForceNew] = useState(false);
	const [isOpened, setIsOpened] = useState(false);

	useEffect(() => {
		signaturePadRef.current?.clear();

		setForceNew(false);
	}, [isOpened]);

	const handleClose = () => {
		setIsOpened(false);
	};

	const handleSave = () => {
		if (value && forceNew === false) {
			handleClose();
			return;
		}
		const svg = signaturePadRef.current?.toSVG();

		if (svg) {
			const isEmpty = /^<svg[^>]*>\s*<\/svg>$/.test(svg);

			if (isEmpty) {
				onChange?.(undefined);
				handleClose();
				return;
			}

			onChange?.(svg);
			handleClose();
			return;
		}
		onChange?.(undefined);
		handleClose();
	};

	const isSignatureSaved = value && forceNew === false;

	return (
		<>
			<Button onClick={() => setIsOpened(true)} type={isSignatureSaved ? 'default' : 'primary'}>
				{isSignatureSaved ? 'Upravit podpis' : buttonText}
			</Button>
			<StyledDrawer open={isOpened} onClose={handleClose}>
				<Typography.Title level={4}>{title}</Typography.Title>
				{value && forceNew === false ? (
					<div
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: value,
						}}
					/>
				) : (
					<SignaturePad
						key={forceNew ? 'new' : 'old'}
						ref={signaturePadRef}
						options={{ backgroundColor: '#FAFAFA' }}
						width={300}
						height={400}
					/>
				)}

				<Footer>
					<Button onClick={handleClose} danger>
						Zrušit
					</Button>
					<Button
						type="default"
						onClick={() => {
							signaturePadRef.current?.clear();
							setForceNew(true);
						}}
					>
						Znovu
					</Button>
					<Button onClick={handleSave} type="primary">
						Uložit
					</Button>
				</Footer>
			</StyledDrawer>
		</>
	);
};

export default SignatureItem;
